.controls {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 12px;
  justify-content: flex-end;
  margin-top: 8px;
}

/* The owner's visit count. Its help box opens below the controls, across the full width. */
.visits {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: auto;
}

.visits [role="note"] {
  top: 100%;
}

.infoModal {
  background-color: white;
  border-radius: 4px;
  max-height: 90%;
  max-width: 90%;
  overflow-y: auto;
  padding: 20px;
}
